import { render, staticRenderFns } from "./TabelaNaoEnviadasCertificacao.vue?vue&type=template&id=13cc532b&scoped=true"
import script from "./TabelaNaoEnviadasCertificacao.vue?vue&type=script&lang=js"
export * from "./TabelaNaoEnviadasCertificacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaNaoEnviadasCertificacao.vue?vue&type=style&index=0&id=13cc532b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc532b",
  null
  
)

export default component.exports